import { Action } from '@ngrx/store';

export const SET_CART_SIZE = '[CART] Set cart size';
export const CLEAN_CART = '[CART] Clean cart';

export class SetCartSize implements Action {
  readonly type = SET_CART_SIZE;

  constructor(public payload: number) {}
}

export class CleanCart implements Action {
  readonly type = CLEAN_CART;

  constructor() {}
}

export type CartActions = SetCartSize | CleanCart | any;
